// extracted by mini-css-extract-plugin
export default {"header":"ACard_header__RXUnl","headerText":"ACard_headerText__-C3Ru","text":"ACard_text__AFssy"};